<div class="w-100 float-left">
    <ng-container *ngIf=!loader>
        <div class="w-100 float-left v-align relative b-b">
            <h5 class="medium float-left">Selected Role</h5>&nbsp; <span>
                <h5 class="medium float-left"> - {{ roleName }}</h5></span>
            <div style="flex-grow: 1;"></div>
            <button class="btn btn-secondary float-right mb-2" (click)="rolesBack()"><i
                    class="fa fa-arrow-left mr-sm-2"></i>Back
            </button>
        </div>
        <div class="w-100 mb-2 mt -2 align-v-center justify-content-between">
            <h5 class="mb-3 medium">Permissions</h5>
            <div class="align-v-center">
                <div class="mr-3">
                    <i class="fa fa-check-circle text-success"></i><span class="ml-2 text-14x">Active</span>
                </div>
                <div class="mr-3">
                    <i class="fa fa-times-circle text-danger"></i><span class="ml-2 text-14x">Inactive</span>
                </div>
                <div class="mr-3">
                    <i class="fa fa-lock"></i><span class="ml-2 text-14x">Lock</span>
                </div>
            </div>
        </div>
        <div class="w-100 float-left" *ngFor="let page of pageList;index as i">
            <div class="w-100 float-left text-13x">
                <div class="w-100 float-left mb-3 hidden-actions">
                    <div class="float-left text-center">
                        <i class="fa float-left mr-3 text-20x"
                           [ngClass]="showChild[i] ? 'fa-caret-down' : 'fa-caret-right'"
                           (click)=toggleChild(i);></i>
                    </div>
                    <div class="float-left text-center">
                        <!-- <div class="checkbox checkbox-primary"> 
                            <input [id]="page.pageCode" type="checkbox" (change)="selectAll(page.id,i)" 
                            [(ngModel)]='selectedAll[i]' >
                            <label [for]="page.pageCode" class="mb-0"></label>
                        </div> -->
                        <div ngbDropdown class="dropdown" placement="bottom-right">
                            <a [id]="page.pageCode" ngbDropdownToggle>
                                <i class="fa" [ngClass]="selectedAll[i] != undefined ? {'fa-check-circle text-success': selectedAll[i] == 0, 'fa-times-circle text-danger': selectedAll[i] == 1, 
                                'fa-lock': selectedAll[i] == 2, 'fa-circle-o':selectedAll[i] == 3} : 'fa-times-circle text-danger'"></i>
                            </a>
                            <div ngbDropdownMenu [attr.aria-labelledby]="page.pageCode">
                                <a class="dropdown-item" (click)="selectAll(page.id,i,0)"><i
                                        class="fa fa-check-circle text-success"></i>Active</a>
                                <a class="dropdown-item" (click)="selectAll(page.id,i,1)"><i
                                        class="fa fa-times-circle text-danger"></i>Inactive</a>
                                <a class="dropdown-item" (click)="selectAll(page.id,i,2)"><i class="fa fa-lock"></i>Lock</a>
                            </div>
                        </div>
                    </div>
                    <div class="float-left text-center">
                        <label for="user1" class="mb-md-0 float-left mr-2 mt-1"></label>
                        <p class="float-left text-14x m-0 ">{{page.name }}</p>
                        <span *ngIf="selectedpsList[i]"
                              class="float-left text-12x m-0 ">&nbsp;(+{{selectedpsList[i]}})</span>
                    </div>
                </div>
                <ng-container *ngIf="showChild[i]">
                    <div class="w-100 float-left pl-5" *ngFor="let section of page.sections">
                        <div class="w-100 float-left mb-3 hidden-actions">
                            <div class="float-left text-center">
                                <!-- <div class="checkbox checkbox-primary">
                                    <input [id]="section.id" type="checkbox"  [attr.value]="page.id" (change)="onChange($event,i)"   
                                    [ngModel]="raMap.get(section.id)" >
                                    <label [for]="section.id" class="mb-0"></label>
                                </div> -->
                                <div ngbDropdown class="dropdown" placement="bottom-right">
                                    <a [id]="section.id" ngbDropdownToggle>
                                        <i class="fa" [ngClass]="raMap.get(section.id) != undefined ? {'fa-check-circle text-success': raMap.get(section.id) == 0, 'fa-times-circle text-danger':
                                        raMap.get(section.id) == 1, 'fa-lock': raMap.get(section.id) == 2} : 'fa-times-circle text-danger'"></i>
                                    </a>
                                    <div ngbDropdownMenu [attr.aria-labelledby]="section.id">
                                        <a class="dropdown-item" (click)="onChange(page.id,section.id,i,0)"><i
                                                class="fa fa-check-circle text-success"></i>Active</a>
                                        <a class="dropdown-item" (click)="onChange(page.id,section.id,i,1)"><i
                                                class="fa fa-times-circle text-danger"></i>Inactive</a>
                                        <a class="dropdown-item" (click)="onChange(page.id,section.id,i,2)"><i
                                                class="fa fa-lock"></i>Lock</a>
                                    </div>
                                </div>
                            </div>
                            <div class="float-left text-center">
                                <label for="user1" class="mb-md-0 float-left mr-2 mt-1"></label>
                                <p class="float-left text-14x m-0 ">{{section.name}} ({{section.pageSectionCode}})</p>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
        <button class="btn btn-primary float-right" (click)="SaveChanges()" [disabled]="!saveChangesButton">Update
        </button>
        <button class="btn btn-secondary float-right mr-4" (click)="rolesBack()">Cancel</button>
    </ng-container>
    <div class="w-100 min-h2 relative" *ngIf="loader">
        <loader></loader>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/bi/admin/controller/editRoleAuthorization.component.html